module.exports = __webpack_public_path__ + "img/icons.f5bd236d.svg";